// extracted by mini-css-extract-plugin
export default {"versionSummaryContainer":"FBA0Po3AGH_cZJ9x6_7G"};